import React from 'react';
import { useTranslation } from 'react-i18next';
import { LogoIcon } from 'svgs';

const InvalidLink: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={'flex justify-center px-[25px] py-[27px]'}>
      <div className={'max-w-full'}>
        <LogoIcon className={'mb-9'} fontSize={'large'} />
        <h1 className={'mb-4 heading-30'}>
          {t('cashenroll.invalidLink.title')}
        </h1>
        <p className={'mb-8 paragraph-30'}>
          {t('cashenroll.invalidLink.subtitle')}
        </p>
      </div>
    </div>
  );
};

export default InvalidLink;
